export const createInitials = (name = ''): string => {
  const splitName = name.split(' ')
  return splitName
    .filter((part, i, list) => {
      return part.length && (i === 0 || i === list.length - 1)
    })
    .map(s => s.trim().charAt(0))
    .join('')
    .toUpperCase()
}

export const getUserInitials = (user = { identifier: '' }): string =>
  createInitials(getUserDisplayName(user))

export type UserIdentity = {
  first_name?: string
  last_name?: string
  identifier: string
}

export const getUserDisplayName = (
  user: UserIdentity = { identifier: '' }
): string =>
  [user.first_name, user.last_name].filter(Boolean).join(' ').trim() ||
  user.identifier
